export const Header = () => {
  return (
    <header className="admin__header">
      <h1 className="admin__header--title">DYWLF? ADMIN PANEL</h1>
    </header>
  );
};
